import { commonUtils } from './common_utils';

export const adCampaign = {
    campaignPunchlineTextLimit: 150,
    campaignBodyTextLimit: 5000,
    showTextAreaLimitText() {
        // Ad campaign fields related text limit events
        if ($('#punchline').length) {
            commonUtils.showTextAreaLimitText('punchline', 'punchlineTextLimit', this.campaignPunchlineTextLimit);
            commonUtils.showTextAreaLimitText('campaignBody', 'campaignBodyTextLimit', this.campaignBodyTextLimit);
        }
    },
    enableDisableCampaignBodyTextarea() {
        const $campaignBodyTextContainer = $('#campaignBodyTextContainer');
        const $campaignBody = $('#campaignBody');
        const punchline = $.trim($('#punchline').val());

        if (punchline) {
            $campaignBodyTextContainer.removeClass('disable_block');
            $campaignBody.prop('disabled', false);
        } else if (!$('#adCampaignRemoveConfirmation').length) {
            $campaignBodyTextContainer.addClass('disable_block');
            $campaignBody.prop('disabled', true);
        }
        adCampaign.showTextAreaLimitText();
    },
    showAdCampaign() {
        if ($('.campaignInfoBadge').length) {
            const $campaignInfoDetail = $('#campaignInfoDetail');
            if ($campaignInfoDetail.length) {
                const adId = $('#adDetailPage').data('ad-id') || '';
                const userId = $('#dealerWebsiteLinkText').data('dealer-id') || '';
                let params = `adId=${adId}&userId=${userId}`;
                $.get(Routing.generate('ad_campaign_detail'), params, function (response) {
                    if (response?.ad_campaign_html) {
                        $campaignInfoDetail.html(response.ad_campaign_html).show();
                        $('.campaignInfoBadge').show();
                    }
                });
            }
        }
    },
    removeAdCampaign(adId) {
        const validAdId = adId || 0;
        if (validAdId > 0) {
            $.ajax({
                type: 'DELETE',
                url: Routing.generate('remove_ad_campaign'),
                async: false,
                data: `adId=${validAdId}`,
                success(response) {
                    if (response.success) {
                        const $punchline = $('#punchline');
                        $('#punchline, #campaignBody, #isAdCampaignExist').val('');
                        $('.removeAdCampaign').remove();
                        $punchline.closest('.form-row_invalid').find('.form-row__error-msg').remove();
                        $punchline.closest('.form-row_invalid').removeClass('form-row_invalid');
                        adCampaign.showTextAreaLimitText();
                        $punchline.trigger('change');
                        window.$.colorbox.close();
                    }
                },
                statusCode: {
                    403() {
                        alert(Translations.invalid_request);
                        window.$.colorbox.close();
                    },
                },
            });
        }
    },
};

$(function () {
    const $body = $('body');

    // Enable/disable campaign body text area on ad posting page
    $body.on('keyup', '#punchline', function () {
        if ($('.postAdValidation').data('is-new-ad')) {
            adCampaign.enableDisableCampaignBodyTextarea();
        }
    });

    // Remove ad campaign from edit ad page
    $body.on('click', '#removeAdCampaign', function () {
        const adId = $(this).data('adid');
        adCampaign.removeAdCampaign(adId);
    });

    // Show/hide campaign description/body on VIF page
    $body.on('click', '.campaignReadMoreLink', function () {
        $(this).parent().closest('.campaignWrapper').toggleClass('details-Dealer-Campaign__Show-More');
    });

    // Add dataLayer event for ad page campaign show more link
    $body.on('click', '#campaignShowMoreText', function () {
        commonUtils.dataLayer.genericData({
            event: 'adPageCampaignShowMoreLink',
        });
    });
});
